import { Box, BoxProps } from '@mui/material';

type SidebarIconName = 'sports' | 'live' | 'casino';

type SidebarSpriteIconProps = Omit<BoxProps, 'children'> & {
  name: SidebarIconName;
  selected?: boolean;
};

const SIDEBAR_SPRITE_CONFIG: Record<
  SidebarIconName,
  { default: { x: number; y: number }; selected: { x: number; y: number }; width: number; height: number }
> = {
  sports: { default: { x: 6, y: 6 }, selected: { x: 75, y: 6 }, width: 26, height: 24 },
  casino: { default: { x: 316, y: 5 }, selected: { x: 397, y: 5 }, width: 24, height: 26 },
  live: { default: { x: 146, y: 10 }, selected: { x: 226, y: 10 }, width: 35, height: 17 },
};

const SidebarSpriteIcon = ({ name, selected = false, sx, ...props }: SidebarSpriteIconProps) => {
  const config = SIDEBAR_SPRITE_CONFIG[name];
  const position = selected ? config.selected : config.default;

  const containerHeight = 26;
  const offsetY = Math.max(0, containerHeight - config.height);

  return (
    <Box
      sx={{
        width: config.width,
        height: containerHeight,
        backgroundImage: 'url(/sidebar-sprite.svg)',
        backgroundPosition: `-${position.x}px -${position.y - offsetY}px`,
        backgroundRepeat: 'no-repeat',
        ...sx,
      }}
      {...props}
    />
  );
};

export default SidebarSpriteIcon;
